import { c as _c } from "react/compiler-runtime";
import { cn } from "@saridana-core/react-ui-kit";
import { SocialLink } from "@shared/types";
import { FacebookIcon, InstagramIcon, LinkedinIcon, TiktokIcon, YoutubeIcon } from "@shared/ui/custom-icon";
import Link from "next/link";
import React from "react";
export function FooterSocialLink(t0) {
  const $ = _c(5);
  const {
    data
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      youtube: <YoutubeIcon className="size-6" />,
      facebook: <FacebookIcon className="size-6" />,
      tiktok: <TiktokIcon className="size-6" />,
      instagram: <InstagramIcon className="size-6" />,
      linkedin: <LinkedinIcon className="size-6" />
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const iconMapping = t1;
  const t2 = iconMapping[data.type];
  let t3;
  if ($[1] !== data.id || $[2] !== data.link || $[3] !== t2) {
    t3 = <Link key={data.id} href={data.link} target="_blank" className="rounded-md size-9 inline-flex items-center justify-center text-center text-gray-500 bg-gray-50 hover:bg-primary-50 hover:text-primary">{t2}</Link>;
    $[1] = data.id;
    $[2] = data.link;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}